module.exports = __webpack_public_path__ + "img/brasil.100681cf.svg";